import { Axios } from './Axios';

export async function getClassAttendances(classId, from, to = '') {
  let url = `/classes/${classId}/attendance?from=${from}`;
  if (to) {
    url = `/classes/${classId}/attendance?from=${from}&to=${to}`;
  }
  return Axios({
    url,
    method: 'get'
  });
}

export async function createAttendance(classId, obj) {
  const url = `/classes/${classId}/attendance`;
  return Axios({
    url,
    method: 'post',
    data: obj
  });
}

export async function updateAttendance(classId, attendanceId, obj) {
  const url = `/classes/${classId}/attendance/${attendanceId}`;
  return Axios({
    url,
    method: 'patch',
    data: obj
  });
}
